
import Vue from 'vue';
import Component from "vue-class-component";
import SectionPageHeading from "@/features/shared/components/sections/SectionPageHeading.vue";
import HeadingWave from "@/features/shared/components/HeadingWave.vue";
import {
    AddTemplateRequest,
    factory,
    ResultError, 
    SysAdminTemplatesClient
} from "@/api-client";
import toasts from "@/components/Toasts";
import AdministrationDetailviewLayout from "@/features/administration/AdministrationDetailviewLayout.vue";
import ErrorsSummary from "@/components/ErrorsSummary.vue";

@Component({
    components: {
        SectionPageHeading,
        HeadingWave,
        AdministrationDetailviewLayout,
        ErrorsSummary
    }
})
export default class AddApplicationTemplate extends Vue {
    model: AddTemplateRequest = factory.create(AddTemplateRequest);
    templateJson = "";
    validationError: ResultError = ResultError.createEmpty();
    
    async save(dryRun: boolean) {
        this.validationError.clear();
        this.model.dryRun = dryRun;
        
        try {
            this.model.templateJson = JSON.parse(this.templateJson);
        } catch (error) {
            this.validationError.appendMessage(this.$ls.Administration_Validation_JsonIsInvalid);
            toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
            return;
        }
        
        await new SysAdminTemplatesClient().add(this.model)
            .then(
                successResponse => {
                    if (!this.model.dryRun) {
                        this.$router.push({ name: 'application-templates' });
                        toasts.success(this.$ls.Administration_ApplicationTemplates_ApplicationTemplateSaved);
                    } else {
                        toasts.success(this.$ls.Administration_Toast_Success_JsonIsValid);
                    }
                },
                (errorResponse: ResultError) => {
                    this.validationError = errorResponse;
                    toasts.failure(this.$ls.Global_Toast_ActionFailureWithErrorsAbove);
                });
    }
}
